import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TIncrementDecrementDeskstop } from '../models';
import { VIEW } from '../configs';

export const IncrementDecrement: FC<TIncrementDecrementDeskstop> = ({
    ButtonDecrease,
    ButtonIncrease,
    Text,
    classNames = {},
    configs,
    dataTestId,
    initialValue,
    isMaximum = false,
    isMinimum = false,
    onDecrease,
    onIncrease,
    separateThousands,
    size = 3,
    styles,
    suffix = configs.SUFFIX,
    theme = 'light',
}) => {
    const amountValue = `${separateThousands(initialValue)} ${suffix}`;

    return (
        // ToDo: Артемьев Федор, поправить добавление стилей (попробовать &)
        <div className={cn(styles.amountValue, classNames.amountValue)}>
            <ButtonDecrease disabled={isMinimum} onClick={onDecrease} theme={theme} />
            <Text
                className={cn(styles.external, styles.value, {
                    [styles.valueFontSize]: !size,
                    [styles.valueWidth]: !classNames.valueWidth,
                    [classNames.valueWidth]: classNames.valueWidth,
                })}
                dataTestId={dataTestId}
                styler={{ margin: 0 }}
                theme={theme}
                view={VIEW[size]}
            >
                {amountValue}
            </Text>
            <ButtonIncrease disabled={isMaximum} onClick={onIncrease} theme={theme} />
        </div>
    );
};
